export default __webpack_public_path__ + "static/media/O-153.64d179c7.png";